import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../atoms/modal/Modal';
import Textlink from '../atoms/link/Textlink';
import LinkButton from '../atoms/button/LinkButton';

const ModalGiftCardCaption = ({ open, onClose }) => {
  const giftCardLink = 'https://www.nta.co.jp/nrs/gift.htm';
  const dreamCardLink = 'https://www.nta.co.jp/nrs/dreamplan.htm';

  return (
    <Modal
      open={open}
      onClose={onClose}
      className="captionModal"
      bodyClassName="cautionModalBody"
      overlayClassName="cautionModalOverlay"
      customHeader={() => (
        <div className="captionModalHeader">
          <div className="captionModalHeaderTitle">日本旅行ギフトカード・ドリーム旅行カードについて</div>
          <div className="cautionModalClose" onClick={onClose}/>
        </div>
      )}
    >
      <div className="campaignCaption">
        ご利用可能なカード、ご利用条件につきましては詳細ページをご覧ください。<br />
        <span style={{ paddingLeft: 8 }}>{'>'}</span>
        <Textlink to={giftCardLink} outgoing>日本旅行ギフトカード</Textlink>
        <span style={{ paddingLeft: 8 }}>{'>'}</span>
        <Textlink to={dreamCardLink} outgoing>ドリーム旅行カード</Textlink><br />
        ※ご利用の際併用できる決済方法はクレジットカードのみとなります。
      </div>
      <div style={{ textAlign: 'center', marginTop: 25 }}>
        <LinkButton buttonType="navigateMin" onClick={onClose}>閉じる</LinkButton>
      </div>
    </Modal>
  );
};

ModalGiftCardCaption.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalGiftCardCaption;
